import HelloWorld from '@/components/HelloWorld'
import {
	Login,
	User,
	Content,
	Product,
	Order,
	FlowLog,
	Dashboard,
	Detail
} from '../views/'
import {
	Home
} from '../layout/'


export default [{
		path: '/',
		name: 'cms',
		redirect: '/login'
	},
	{
		path: '/login',
		name: '登录',
		hidden: true,
		meta: {
			noRequireAuth: true,
			application: ['notInTab', 'notInAuth']
		},
		component: Login
	},
	{
		path: '/home',
		name: 'home',
		component: Home,
		meta: {},
		children: [{
				path: 'dashboard',
				name: '控制面板',
				component: Dashboard.Dashboard
			},

			{
				path: 'adminLists',
				name: '管理员列表',
				component: User.AdminLists
			},
			{
				path: 'role',
				name: '角色管理',
				component: User.Role
			},
			{
				path: 'access',
				name: '权限管理',
				component: User.Access
			},
			{
				path: 'Personal',
				name: '司机管理',
				component: User.Personal
			},
			{
				path: 'user',
				name: '用户管理',
				component: User.User
			},
			{
				path: 'thirdApp',
				name: '平台管理',
				component: User.ThirdApp
			},
			{
				path: 'config',
				name: '项目配置',
				component: User.Config
			},

			{
				path: 'label',
				name: '文章菜单管理',
				component: Content.Label
			},
			{
				path: 'Article',
				name: '文章管理',
				component: Content.ArticleLists
			},
			{
				path: 'message',
				name: '消息管理',
				component: Content.Message
			},
			{
				path: 'banner',
				name: '首页轮播',
				component: Content.Banner
			},
			{
				path: 'notice',
				name: '公告管理',
				component: Content.Notice
			},
			{
				path: 'plate',
				name: '平台信息',
				component: Content.Plate
			},
			{
				path: 'express',
				name: '快递公司管理',
				component: Content.Express
			},

			{
				path: 'productLabel',
				name: '商品类别',
				component: Product.ProductLabel
			},
			{
				path: 'product',
				name: '商品管理',
				component: Product.Product
			},
			{
				path: 'skuLabel',
				name: 'SKU类别',
				component: Product.SkuLabel,
			},
			{
				path: 'sku',
				name: 'SKU管理',
				component: Product.Sku,
			},
			{
				path: 'coupon',
				name: '积分优惠券',
				component: Product.Coupon
			},
			{
				path: 'tproduct',
				name: '特卖商品',
				component: Product.Tproduct
			},
			{
				path: 'card',
				name: '提货卡商品',
				component: Product.Card
			},
			{
				path: 'cardInfo',
				name: '提货卡信息',
				component: Product.CardInfo
			},
			{
				path: 'productpage/:id',
				name: '商品详情',
				meta: {
					clearFullPath: '/home/productpage'
				},
				component: Detail.Productpage
			},


			{
				path: 'order',
				name: '订单管理',
				component: Order.Order
			},
			{
				path: 'cardorder',
				name: '提货卡订单',
				component: Order.Cardorder
			},
			{
				path: 'pay',
				name: '支付流水',
				component: FlowLog.Pay
			},
			{
				path: 'balance',
				name: '余额流水',
				component: FlowLog.Balance
			},
			{
				path: 'score',
				name: '积分流水',
				component: FlowLog.Score
			},
			{
				path: 'withdraw',
				name: '提现管理',
				component: FlowLog.Withdraw
			},

		]
	}
]



// WEBPACK FOOTER //
// ./src/router/mainRouter.js